import { Module, ActionContext } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';
import { currentUserKey } from '@/shared/msw-constants';
import { StoreInputParameters } from '@/services/idbStore.interface';
import idb, { CSC_STORE_NAME } from '@/services/indexedDb.service';
import { tokenExpirationService } from './token-expiration.service';

export interface SpogHomePageStoreState {
}
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    async getTenantDetail(context: ActionContext<SpogHomePageStoreState, RootStoreState>, requestBody: any) {
      if (tokenExpirationService.checkIfTokenExpired()) {
        await context.dispatch('getTokenAndUpdateLocalstorage');
      } else {
        console.warn('not expired');
      }
      context.commit('startLoading', null, { root: true });
      let id = '';
      const userObj = localStorage.getItem(currentUserKey);
      if (userObj) {
        if (JSON.parse(userObj)) {
          id = JSON.parse(localStorage.getItem(currentUserKey) as any).userId;
        } else {
          id = 'anonymous';
        }
      } else {
        id = 'anonymous';
      }
      let endpoint = '';
      if (requestBody) {
        endpoint = `hgms/get-cloud-tenants?username=${id}&bisfromCSC2=true&isforced=true`;
      } else {
        endpoint = `hgms/get-cloud-tenants?username=${id}&bisfromCSC2=true`;
      }
      const request: StoreInputParameters = { endpoint, payload: {}, forceFetch: requestBody, objectName: CSC_STORE_NAME, httpMethod: 'get' };
      let idbData: any = null;
      try {
        idbData = await idb.getData(request, ['MSWAPP:SUCCESS', 'MSWAPP:NOTENANTES'], '');
      } catch (e) {
        console.error(e);
      }
      return Promise.resolve(idbData);
      // return ApiServiceWrapper.get(endpoint);
    },
    async getTokenAndUpdateLocalstorage(context: ActionContext<SpogHomePageStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      await context.dispatch('exchangeCodeForToken', { refreshToken : tokenExpirationService.getRefreshToken() })
        .then((response : any) => {
          const localStoargeData = JSON.parse(localStorage.getItem(currentUserKey)!);
          if (response.content.token && localStoargeData) {
            localStoargeData.token = response.content.token;
            localStorage.setItem(currentUserKey, JSON.stringify(localStoargeData));
          }
          context.commit('stopLoading', null, { root: true });
        });
    },
    async getTenantDetailWithoutCache(context: ActionContext<SpogHomePageStoreState, RootStoreState>, requestBody: any) {
      if (tokenExpirationService.checkIfTokenExpired()) {
        await context.dispatch('getTokenAndUpdateLocalstorage');
      }
      let id = '';
      const userObj = localStorage.getItem(currentUserKey);
      if (userObj) {
        if (JSON.parse(userObj)) {
          id = JSON.parse(localStorage.getItem(currentUserKey) as any).userId;
        } else {
          id = 'anonymous';
        }
      } else {
        id = 'anonymous';
      }
      let endpoint = '';
      if (requestBody) {
        endpoint = `hgms/get-cloud-tenants?username=${id}&bisfromCSC2=true&isforced=true`;
      } else {
        endpoint = `hgms/get-cloud-tenants?username=${id}&bisfromCSC2=true`;
      }
      context.commit('startLoading', null, { root: true });
      return ApiServiceWrapper.get(endpoint);
    },
    async postDisableMessage(context: ActionContext<SpogHomePageStoreState, RootStoreState>, requestBody: any) {
      if (tokenExpirationService.checkIfTokenExpired()) {
        await context.dispatch('getTokenAndUpdateLocalstorage');
      }
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/enable-disable-highlighter';
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
    logout(context: ActionContext<SpogHomePageStoreState, RootStoreState>, requestBody: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'log-out';
      return ApiServiceWrapper.post(endpoint, requestBody);
    },
    async uploadImage(context: ActionContext<SpogHomePageStoreState, RootStoreState>, requestBody: any) {
      if (tokenExpirationService.checkIfTokenExpired()) {
        await context.dispatch('getTokenAndUpdateLocalstorage');
      }
      context.commit('startLoading', null, { root: true });
      const formData = new FormData();
      formData.append('myFile', requestBody.file, requestBody.file.name);
      const endpoint = `hgms/upload-logo?productgroupid=${requestBody.tenantId}`;
      return ApiServiceWrapper.post(endpoint, formData);
    },
    async getProductDetail(context: ActionContext<SpogHomePageStoreState, RootStoreState>, serialNumber: string) {
      if (tokenExpirationService.checkIfTokenExpired()) {
        await context.dispatch('getTokenAndUpdateLocalstorage');
      }
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/product-detail?serialnumber=${serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    async saveTenantList({}, payload : any) {
      await idb.saveData(CSC_STORE_NAME, payload);
      return;
    },
    getCscAccessCode(context: ActionContext<SpogHomePageStoreState, RootStoreState>, request: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'generate-cscaccesscode';
      return ApiServiceWrapper.post(endpoint, request);
    },
    async exchangeCodeForToken(context: ActionContext<SpogHomePageStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'exchange-cscaccesscode';
      return ApiServiceWrapper.post(endpoint, payload);
    },
  },
  getters: {
  },
  namespaced: true,
} as Module<SpogHomePageStoreState, RootStoreState>;
